// extracted by mini-css-extract-plugin
export default {"separator":"f3242f3d6c6f"};